import { render } from "./QuestionDataDetailList.vue?vue&type=template&id=dae126fa&scoped=true"
import script from "./QuestionDataDetailList.vue?vue&type=script&lang=js"
export * from "./QuestionDataDetailList.vue?vue&type=script&lang=js"

import "./QuestionDataDetailList.vue?vue&type=style&index=0&id=dae126fa&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae126fa"]])

export default __exports__